import * as React from 'react';
import { Avatar, Card, CardActionArea, CardContent, Typography, CardMedia } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { apiBaseUrl } from '../utils/Api/Api';
import Pets from '@mui/icons-material/Pets';

const PetCard = (props) => {
  const { pet } = props;
  const navigate = useNavigate();

  return (
    <Card sx={{ flexGrow: 1 }}>
      <CardActionArea onClick={() => navigate(`/mypets/${pet.id}/details`)}>
      {pet.avatar_url ? (
        <CardMedia
          component="img"
          height="140"
          image={`${apiBaseUrl}/${pet.avatar_url}`}
        />
      ) : (
        <Avatar sx={{ width: 160, height: 160, margin: 'auto', marginTop: 2, marginBottom: 2, border: '1px solid lightgray' }}>
          <Pets sx={{ width: 48, height: 48 }} />
        </Avatar>
      )}
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {pet.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {pet.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default PetCard